<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        :showEdit="false"
        :title="title"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
        :key="open"
      >
        <Form
          ref="formOrder"
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :multiple="true"
          
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import relations from "@/store/autorizaciones/relations";
import comments from "@/store/comentarios/comentarios"
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.comments"),
      titleTable: "Roles_Comentarios",
      titleDelete: this.$tc("autoriz.toCommenToRol"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Comentario",
          value: "coment",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Codigo Aplica",
          value: "codeApply",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      selectAutoriza: [
        {
          name: "No autoriza",
          value: 0,
        },
        {
          name: "Autoriza",
          value: 1,
        },
        {
          name: "Según autorización previa",
          value: 2,
        },
      ],
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await relations.dispatch("getRolComents");

    await comments.dispatch("getComment");
    this.isLoading = false;
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !relations.state.coments ||
        relations.state.coments === 0
      ) {
        return []; 
      } else {
        return relations.state.coments
      }
    },

    comments() {
      return comments.state.comment;
    },

   commentsSelected() {
    const editcomments = this.editcomments;
    const filteredComments = comments.state.comment.filter((coment) => {
        const isSelected = editcomments?.some((selected) => {
            return selected.id === coment.comentId;
        });
        return !isSelected;
    });
    return filteredComments;
},
    editcomments() {
      return relations.state.coments;
    },

    dataSelects() {
      return [
        {
          name: "idComent",
          label: "Comentarios",
          data: "",
          items: [],
          itemsValue: "comentId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false
        },
      ];
    },

    mode: {
      get() {
        return relations.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return relations.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return relations.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
   
     triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },
    async refreshItems() {
      if (relations.state.edit.id) {
        await relations.dispatch(
          "getRolComents"
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },


    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.commentsSelected;
          relations.commit("setMode", this.$tc("autoriz.addCommenToRol")
          );
          relations.commit("setOpen", true);
          break;
        case "delete":
          relations.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            rolId: relations.state.edit.id,
          };
          break;
        default:
          break;
      }
    },

    reset(value) {
      relations.commit("setOpen", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
        item.items = [];
      });
    },
   
    saveForm(items) {
      if(this.typeForm =="add") {
         return this.addComent(items);
      }
    },

    async addComent(form) {
      let payload = {
          idsComents: form.idComent.split(',').map(id => parseInt(id, 10)), 
        rolId: relations.state.edit.id,
      };
      relations.commit("setNew", payload);
      relations.dispatch("addRolComent")
        .then(() => {
          relations.dispatch("getRolComents");
          this.showAlert(
            this.$tc("autoriz.addCommenToRolSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("autoriz.errorComment"),
            "#ff8d58"
          );
        });

      this.reset(false);
    },

    deleteItem() {
      relations.commit("setItemDelete", this.itemToDelete);
      relations
        .dispatch("deleteRolComent")
        .then(() => {
          this.openDelete = false;
          relations.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("autoriz.deleteCommenToRolSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("autoriz.errorComment"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      relations.commit("setOpenDelete", false);
    },
  },
};
</script>
